import { render, staticRenderFns } from "./tips_block.vue?vue&type=template&id=21b72597&"
import script from "./tips_block.vue?vue&type=script&lang=js&"
export * from "./tips_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports